export default __webpack_public_path__ + "3b35473be96550cdb93234e6e9a47396.jpg";